"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateTypes = exports.TemplateType = void 0;
var TemplateType;
(function (TemplateType) {
    TemplateType["HTML"] = "HTML";
    TemplateType["JSON"] = "JSON";
    TemplateType["CSV"] = "CSV";
    TemplateType["Markdown"] = "MARKDOWN";
    TemplateType["FilePath"] = "FILE_PATH";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
exports.TemplateTypes = [TemplateType.HTML, TemplateType.JSON, TemplateType.CSV, TemplateType.Markdown, TemplateType.FilePath];
//# sourceMappingURL=template.js.map